import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import { renderSingleSpec } from '../../Specs'
import HighlightedText from '../../../../Utils/HighlightedText'

function R295Specs({ titleHl, text, specs }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.title}>
            <HighlightedText {...titleHl}
                             highlightExactMatch={true}
            />
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text} noSpace/>
          </div>
        </div>
        <div className={`${styles.specsWrapper} ${styles.specsWrapperDesktop}`}>
          { renderSpecs(specs, 3) }
        </div>
        <div className={`${styles.specsWrapper} ${styles.specsWrapperMobile}`}>
          { renderSpecs(specs, 2) }
        </div>
      </div>
    </div>
  )
}

const renderSpecs = (specs, specsPerRow) => {
  const numRows = specs.length / specsPerRow
  return Array.from(Array(numRows)).map((x, numRow) => {
    return (
      <>
        <div className={styles.specsRow}>
          {
            [...specs]
              .splice((numRow + 1) * specsPerRow - specsPerRow, specsPerRow)
              .map((spec, i) => (
                <>
                  <div className={styles.verticalLine}/>
                  { renderSingleSpec(spec.title, spec.subtitle, spec.icon, true) }
                  { i + 1 === specsPerRow && <div className={styles.verticalLine}/> }
                </>
              ))
          }
        </div>
        { numRow + 1 < numRows && <div className={styles.specsRow}>
          { Array.from(Array(specsPerRow)).map((x, i) => <div className={styles.horizontalLine} key={i}/>)}
        </div>
        }
      </>
    )
  })
}

export default R295Specs
